/**
 * Recording-mode union shared with GET /auth/me.
 * The live switch lives in backend/src/shared/config/treatmentRecordingMode.ts.
 */
export const TREATMENT_RECORDING_MODES = ['catalog_steps', 'treatment_journal'] as const;

export type TreatmentRecordingMode = (typeof TREATMENT_RECORDING_MODES)[number];

export const DEFAULT_TREATMENT_RECORDING_MODE: TreatmentRecordingMode = 'catalog_steps';

export const isTreatmentJournalMode = (
  mode?: string | null
): mode is 'treatment_journal' => mode === 'treatment_journal';
